// extracted by css-extract-rspack-plugin
export default {"cls1":"BibliographyList-cls1_D83","cls2":"BibliographyList-cls2__Xg BibliographyList-cls1_D83"};